import { Button, Flex, Loading, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import type { DropzoneOptions } from 'react-dropzone';
import { useDropzone } from 'react-dropzone';

import styles from './fileUploadArea.module.css';

export interface FileUploadAreaProps extends DropzoneOptions {
  /** Optional class name for custom styling */
  className?: string;

  /** Label to describe drag and drop option */
  dragLabel?: string;

  /** When true, component renders loading symbol */
  isLoading: boolean;

  /** Label to describe upload from computer option */
  label?: string;
}

export const FileUploadArea = ({
  className,
  dragLabel = 'Drag and drop images here',
  isLoading,
  label = 'Upload images from computer',
  ...dropzoneOptions
}: FileUploadAreaProps) => {
  const { getRootProps, getInputProps, open } = useDropzone({
    multiple: false,
    noClick: true,
    ...dropzoneOptions,
  });

  return (
    <div className={clsx(styles['uploadArea'], className)} {...getRootProps()}>
      <Flex
        gap={12}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        aria-label={`${label} or ${dragLabel}`}
      >
        {isLoading ? (
          <div className={styles['loadingContainer']}>
            <Loading color="black" data-testid="loading-file-upload" />
          </div>
        ) : (
          <>
            <Button variant="secondary" label={label} onClick={open} />
            <input
              data-testid="file-upload"
              aria-label={label}
              {...getInputProps()}
            />
            <Typography color="grays-mid">or</Typography>
            <Typography color="grays-mid">{dragLabel}</Typography>
          </>
        )}
      </Flex>
    </div>
  );
};
